export var alertColors = {
  background: {
    info: "var(--CDS-color-semantic-feedback-info-surface)",
    critical: "var(--CDS-color-semantic-feedback-critical-surface)",
    success: "var(--CDS-color-semantic-feedback-positive-surface)",
    warning: "var(--CDS-color-semantic-feedback-warning-surface)"
  }
};